import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';

import Development from './components/core/Development.vue';
import App from './App.vue';

Vue.config.productionTip = process.env.NODE_ENV === 'development';

Vue.use(VueScrollTo);

Vue.component('development', Development);

Vue.filter('json', function (obj: any) {
  return JSON.stringify(obj, null, ' ');
});

new Vue({
  render: h => h(App)
}).$mount('#app');
